export class LifecycleGuard {
  private active = false;
  private generation = 0;

  mount(): number {
    this.active = true;
    return ++this.generation;
  }

  invalidate(): number {
    return ++this.generation;
  }

  unmount(): void {
    this.active = false;
    this.generation += 1;
  }

  capture(): number {
    return this.generation;
  }

  isCurrent(generation: number): boolean {
    return this.active && generation === this.generation;
  }
}
